import { get as _get } from 'lodash-es';
export default (_specAxios) => ({
  namespaced: true,
  state: {
    userStateId: null,
    userUuid: null,
    tutorialId: null,
    currentPage: null,
    completed: null,
    star: null,
    timeSpent: null,
    startedAt: null
  },
  mutations: {
    fillState(state, { values }) {
      if (!values) return;
      Object.keys(state).forEach((attr) => {
        state[attr] = values[attr];
      });
    }
  },
  getters: {
    api(state, getters, rootState, rootGetters) {
      // Control special axios instance
      if (_specAxios) return _specAxios;

      if (!rootGetters['CodementumUser/api'])
        throw new Error('You must initialize the CodementumNavbarPlugin');
      else return rootGetters['CodementumUser/api'];
    }
  },
  actions: {
    async create({ getters }, { tutorialId }) {
      const res = await getters.api.post('../appmaker/userstates', {
        // userUuid: rootState.CodementumUser.account.uuid, // not need now
        tutorialId
      });

      if (res.data.success) return Promise.resolve(res.data.data);
      else return Promise.reject(true);
    },
    async fetch({ rootState, commit, getters }, { tutorialId }) {
      const res = await getters.api.get('../appmaker/userstates', {
        params: {
          search:
            'userUuid==' +
            rootState.CodementumUser.account.uuid +
            ' and tutorial.id==' +
            tutorialId
        }
      });

      if (res.data.success) {
        if (res.data.data.list.length)
          commit('fillState', { values: res.data.data.list[0] });
        return Promise.resolve(res.data.data);
      } else return Promise.reject(true);
    },
    async patch({ state, getters }, data) {
      const res = await getters.api.patch(
        '../appmaker/userstates/' + state.userStateId,
        data
      );

      if (res.data.success) return Promise.resolve(res.data.data);
      else return Promise.reject(true);
    },
    async addSolution(
      { rootState, getters },
      { solution, star, timeSpent, startedAt, finishedAt, pageId }
    ) {
      const res = await getters.api.post('../appmaker/solutions', {
        userUuid: rootState.CodementumUser.account.uuid,
        solution,
        star,
        timeSpent,
        startedAt,
        finishedAt,
        pageId
      });

      if (res.data.success) return Promise.resolve(res.data.data);
      else return Promise.reject(true);
    }
  }
});
